import React from 'react';
import {
    Activity,
    AlarmClock,
    AlertTriangle,
    Archive,
    ArrowLeft,
    ArrowRight,
    BarChart3,
    Bell,
    Bot,
    CalendarDays,
    Calculator,
    Car,
    CarFront,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    CircleAlert,
    CircleCheck,
    ClipboardList,
    Clock,
    CloudUpload,
    Coins,
    Command,
    Copy,
    Database,
    Download,
    Edit,
    Eye,
    FileSpreadsheet,
    FileText,
    Folder,
    GitCompare,
    Home,
    Info,
    KeyRound,
    Landmark,
    LayoutDashboard,
    Lightbulb,
    LineChart,
    List,
    ListChecks,
    Lock,
    LogOut,
    Mail,
    Menu,
    Minus,
    MoreHorizontal,
    Paperclip,
    Phone,
    Plane,
    Plus,
    Printer,
    Receipt,
    RefreshCw,
    Save,
    ScanSearch,
    Search,
    Settings,
    ShieldAlert,
    ShieldCheck,
    SlidersHorizontal,
    Star,
    Timer,
    Trash2,
    Unlock,
    Upload,
    UserCog,
    Users,
    Vault,
    Wallet,
    Workflow,
    Wrench,
    X,
    XCircle,
    Zap,
} from 'lucide-react';

/**
 * One icon language for the whole product: Lucide line icons.
 * Keys are stable; pages reference them as ICONS.<key>.
 */
export const ICONS = {
    // Modules
    dashboard: <LayoutDashboard />,
    fleet: <Car />,
    car: <CarFront />,
    staff: <Users />,
    contracts: <FileText />,
    document: <FileText />,
    docx: <FileText />,
    expired: <ShieldAlert />,
    operations: <ClipboardList />,
    matcher: <GitCompare />,
    maintenance: <Wrench />,
    booking: <CalendarDays />,
    invoices: <Receipt />,
    reports: <BarChart3 />,
    chart: <LineChart />,
    analysis: <BarChart3 />,
    admin: <UserCog />,
    multi_car: <ScanSearch />,
    airport: <Plane />,
    reminder: <AlarmClock />,
    rta: <AlertTriangle />,
    fines: <AlertTriangle />,
    salik: <Coins />,
    calculator: <Calculator />,
    history: <Clock />,
    clock: <Clock />,
    time: <Timer />,
    cloud_sync: <CloudUpload />,
    wallet: <Wallet />,
    safe: <Vault />,
    checklist: <ListChecks />,
    list: <List />,
    government: <Landmark />,
    database: <Database />,
    engine: <Zap />,
    automation: <Workflow />,
    kpi: <LineChart />,
    folder: <Folder />,
    archive: <Archive />,
    secure: <ShieldCheck />,
    key: <KeyRound />,
    activity: <Activity />,

    // Navigation & chrome
    home: <Home />,
    back: <ArrowLeft />,
    arrowLeft: <ArrowLeft />,
    arrowRight: <ArrowRight />,
    chevronDown: <ChevronDown />,
    chevronUp: <ChevronUp />,
    chevronLeft: <ChevronLeft />,
    chevronRight: <ChevronRight />,
    menu: <Menu />,
    more: <MoreHorizontal />,
    command: <Command />,
    bell: <Bell />,
    logout: <LogOut />,
    search: <Search />,
    filter: <SlidersHorizontal />,
    settings: <Settings />,
    users: <Users />,

    // Actions
    refresh: <RefreshCw />,
    update: <RefreshCw />,
    upload: <Upload />,
    save: <Save />,
    export: <Download />,
    download: <Download />,
    edit: <Edit />,
    delete: <Trash2 />,
    trash: <Trash2 />,
    plus: <Plus />,
    minus: <Minus />,
    copy: <Copy />,
    close: <X />,
    x: <X />,
    check: <Check />,
    print: <Printer />,
    eye: <Eye />,
    visible: <Eye />,
    attach: <Paperclip />,
    lock: <Lock />,
    unlock: <Unlock />,
    mail: <Mail />,
    phone: <Phone />,
    calendar: <CalendarDays />,
    spreadsheet: <FileSpreadsheet />,
    star: <Star />,
    bulb: <Lightbulb />,
    robot: <Bot />,

    // Status
    alert: <AlertTriangle />,
    info: <Info />,
    success: <CircleCheck />,
    warning: <CircleAlert />,
    error: <XCircle />,
};
